import s from "./LanguageSelectionDropDownMenu.module.scss";
import {TLanguageSelectionDropDownMenuProps} from "@/app/[locale]/common/components/LanguageSelectionDropDownMenu/types";
import {usePathname, useRouter} from "@/i18n/routing";

export const LanguageSelectionDropDownMenu = (
    {
        isOpen,
        trigger,
        Icon,
        list,
        topPaddingContent = 'topPaddingLarge',
        triggerColor = 'blackTriggerColor',
        className,
        handleOpen,
        handleClose,
    }: TLanguageSelectionDropDownMenuProps) => {
    const router = useRouter();
    const pathname = usePathname();

    const handleLanguageChange = (locale: string) => {
        router.replace(pathname, { locale });
    };

    return (
        <div
            tabIndex={0}
            className={`${s.dropdownMenu} ${className && className}`}
            onMouseLeave={handleClose}
        >
            <div
                className={`${s.dropdownMenu_trigger} ${s[triggerColor]}`}
                onMouseOver={handleOpen}
            >
                <span className={`${s.dropdownMenu_trigger_iconContainer} ${s.leftIcon}`}>{Icon}</span>
                <span>{trigger}</span>
            </div>

            {
                isOpen &&
                <div className={`${s.dropdownMenuContainer} ${topPaddingContent && s[topPaddingContent]}`}>
                    <ul className={s.dropdownMenuContent}>
                        {list.map((item, index) => (
                            <li key={index} className={s.dropdownMenuItem}>
                                <button onClick={() => handleLanguageChange(item.locale)}>
                                    {item.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            }
        </div>
    );
};